import React, { useEffect, useState } from "react";
import Layout from "../components/Layout/Layout";
import styles from "../styles/order_history.module.css";
import { API_Path } from "../const";
import { GetTokenApi } from "../api/api-service";
import { toast } from "react-toastify";
import moment from "moment";
import DataTableComponents from "../components/data_Table/DataTableComponents";
import { exportTableToExcel, maxDateString, exportTableToPDF } from "../components/common/CommonFun";
import { Table } from "react-bootstrap";
import NoDataFoundImg from "../components/nodatafound/NoDataFoundImg";
import PDFIcon from "../assets/images/file-pdf.svg";
import excelIcon from "../assets/images/microsoft_excel.svg";
import SelectField from "../components/select_option/SelectField";
import DatePicker from "react-datepicker";
import Loader from "../components/loader/Loader";

const option = [
    { value: "Buy", label: "Buy" },
    { value: "Sell", label: "Sell" },
];

export default function OrderHistory() {
    const [coinPairsData, setCoinPairsData] = useState();
    const [userExchangeOrders, setUserExchangeOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("PENDING");
    const [TotalRows, setTotalRows] = useState(5000);
    const [data, setData] = useState({
        fromDate: "",
        todate: "",
        pairFirst: "",
        pairLast: "",
        buySell: "",
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [cancelLoader, setCancelLoader] = useState({});

    var excel_Name = activeTab === "PENDING" ? "open_orders_detail_excel" : activeTab === "ex-cancel" ? "fill_orders_detail_excel" : activeTab === "EXECUTED" ? "trade_history_detail_excel" : "";

    const handleTabClick = (tabKey) => {
        setActiveTab(tabKey);
        GetUserExchangeOrders(currentPage, rowsPerPage, tabKey, data.fromDate, data.todate, data.pairFirst, data.pairLast, data.buySell);
    };

    useEffect(() => {
        GetAllCoinPairsData();
        GetUserExchangeOrders(currentPage, rowsPerPage, activeTab);
    }, []);

    const GetAllCoinPairsData = () => {
        const GetAllOrderHistotyData = new Promise((resolve) => {
            resolve(GetTokenApi(API_Path.GetCoinPairsForFilter));
        });
        GetAllOrderHistotyData.then((res) => {
            if (res?.data) setCoinPairsData(res.data);
        });
    };

    const handlePageChange = (page) => {
        GetUserExchangeOrders(page, rowsPerPage, activeTab, data.fromDate, data.todate, data.pairFirst, data.pairLast, data.buySell);
        setCurrentPage(page);
    };

    const handleRowsPerPageChange = async (newRowsPerPage) => {
        if (!userExchangeOrders.length) return;
        GetUserExchangeOrders(1, newRowsPerPage, activeTab, data.fromDate, data.todate, data.pairFirst, data.pairLast, data.buySell);
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
    };

    const GetUserExchangeOrders = (page, rowPerPage, tabKey, fromdate, todate, firstCoin, lastCoin, buyselldata) => {
        setLoading(true);
        const shortData = tabKey === "PENDING" ? "ENT_DATE_ISO" : tabKey === "ex-cancel" ? "UPD_DATE_ISO" : tabKey === "EXECUTED" ? "UPD_DATE_ISO" : "ENT_DATE_ISO";
        var queryString = `q={PageNo:${page},PageSize:${rowPerPage},SortColumn:"${shortData}",SortDir:"desc",SearchValue:""}&status=${tabKey !== undefined && tabKey !== "" ? tabKey : activeTab}`;
        if (fromdate) queryString += `&fromdate=${moment(data.fromDate).format("yyyy-MM-DD")}`;
        if (todate) queryString += `&todate=${moment(data.todate).format("yyyy-MM-DD")}`;
        if (firstCoin) queryString += `&pairFirst=${data.pairFirst}`;
        if (lastCoin) queryString += `&pairLast=${data.pairLast}`;
        if (buyselldata) queryString += `&buySell=${data.buySell}`;
        const GetUserExchangeOrdersData = new Promise((resolve) => {
            resolve(GetTokenApi(API_Path.GetUserExchangeOrders + queryString));
        });
        GetUserExchangeOrdersData.then((res) => {
            if (res) {
                setUserExchangeOrders(res.data[0]);
                setTotalRows(res.data[1][0].TOTAL_COUNT);
            } else toast.error("Something went wrong!");
            setLoading(false);
            // setTimeout(() => {
            setBtnLoading(false);
            // }, 1000);
        });
        // setLoading(false);
    };
    const handleCancelClick = (id) => {
        setCancelLoader({ [id]: true });
        let placeOrderDetail = new Promise((resolve) => {
            // resolve(GetTokenApi(API_Path.CancelUserOrder + `id=1122667011`));
            resolve(GetTokenApi(API_Path.CancelUserOrder + `id=${id}`));
        });
        placeOrderDetail.then((res) => {
            if (res.data.Isvalid) {
                toast.success(res.data.Successes[0]);
                setCancelLoader({ [id]: false });
                GetUserExchangeOrders(1, 25, activeTab, data.fromDate, data.todate, data.pairFirst, data.pairLast, data.buySell);
            } else {
                toast.error(res.data.Errors[0]);
                setCancelLoader({ [id]: false });
            }
            setCancelLoader({ [id]: false });
        });
    };
    const columns = [
        {
            name: "Created",
            selector: (row) => moment(activeTab === "PENDING" ? row.ENT_DATE_ISO : row.UPD_DATE_ISO).format("DD/MM/YYYY h:mm:ss A"),
            sortable: true,
            cell: (row) => (
                <div>
                    {moment(row.ENT_DATE_ISO).format("DD/MM/YYYY")}
                    <span className="text-secondary d-block"> {moment(row.ENT_DATE_ISO).format("h:mm:ss A")}</span>
                </div>
            ),
        },
        { name: "Pair", selector: (row) => row.CURRENCY_PAIR },
        {
            name: "Buy/Sell",
            selector: (row) => row.BUY_SELL,
            cell: (row) => (
                <div className={row.BUY_SELL === "buy" ? "green_color" : "red_color"} style={{ fontWeight: "600" }}>
                    {row.BUY_SELL === "buy" ? "Buy" : "Sell"}
                </div>
            ),
        },
        { name: "Type", selector: (row) => row.ORDER_TYPE },
        { name: "Order Price", selector: (row) => row.ORDER_PRICE },
        { name: "Volume", selector: (row) => row.ORDER_SIZE },
        { name: "Total", selector: (row) => row.TOTAL_PRICE },
        {
            name: "Action",
            selector: (row) => "Cancel",
            cell: (row) => (
                <button className={styles.btn_oredr} onClick={() => handleCancelClick(row.ID)}>
                    {cancelLoader[row.ID] ? <span className="spinner-border spinner-border-sm " role="status" aria-hidden="true"></span> : "Cancel"}
                </button>
            ),
        },
    ];

    const columns_ex_cancel = [
        {
            name: "Created",
            selector: (row) => row.UPD_DATE_ISO,
            sortable: true,
            cell: (row) => (
                <div>
                    {moment(row.UPD_DATE_ISO).format("DD/MM/YYYY")}
                    <br />
                    <span className="text-secondary"> {moment(row.UPD_DATE_ISO).format("h:mm:ss A")}</span>
                </div>
            ),
        },
        { name: "Pair", selector: (row) => row.CURRENCY_PAIR },
        {
            name: "Buy/Sell",
            selector: (row) => row.BUY_SELL,
            cell: (row) => (
                <div className={row.BUY_SELL === "buy" ? "green_color" : "red_color"} style={{ fontWeight: "600" }}>
                    {row.BUY_SELL === "buy" ? "Buy" : "Sell"}
                </div>
            ),
        },
        { name: "Type", selector: (row) => row.ORDER_TYPE },
        { name: "Order Price", selector: (row) => row.ORDER_PRICE },
        { name: "Volume", selector: (row) => row.ORDER_SIZE },
        { name: "Total Price", selector: (row) => row.TOTAL_PRICE },
        { name: "Deal Price", selector: (row) => row.EXECUTED_PRICE },
        { name: "Deal Amount", selector: (row) => row.DEAL_AMOUNT },
        { name: "Fees", selector: (row) => `${row.FEES} ${row.FEES_CURR}`, cell: (row) => <div className="text-secondary">{`${row.FEES} ${row.FEES_CURR}`}</div> },
        { name: "Paid/Get Paid", selector: (row) => row.FINAL_TOTAL, cell: (row) => <div className={parseFloat(row.FINAL_TOTAL) >= 0 ? "green_color" : "red_color"}>{row.FINAL_TOTAL}</div> },
        activeTab == "ex-cancel" && { name: "Status", selector: (row) => row.STATUS },
    ];
    const columns_EXECUTED = [
        {
            name: "Created",
            selector: (row) => row.UPD_DATE_ISO,
            sortable: true,
            cell: (row) => (
                <div>
                    {moment(row.UPD_DATE_ISO).format("DD/MM/YYYY")}
                    <br />
                    <span className="text-secondary"> {moment(row.UPD_DATE_ISO).format("h:mm:ss A")}</span>
                </div>
            ),
        },
        { name: "Pair", selector: (row) => row.CURRENCY_PAIR },
        {
            name: "Buy/Sell",
            selector: (row) => row.BUY_SELL,
            cell: (row) => (
                <div className={row.BUY_SELL === "buy" ? "green_color" : "red_color"} style={{ fontWeight: "600" }}>
                    {row.BUY_SELL === "buy" ? "Buy" : "Sell"}
                </div>
            ),
        },
        { name: "Type", selector: (row) => row.ORDER_TYPE },
        { name: "Order Price", selector: (row) => row.ORDER_PRICE },
        { name: "Volume", selector: (row) => row.ORDER_SIZE },
        { name: "Total Price", selector: (row) => row.TOTAL_PRICE },
        { name: "Deal Price", selector: (row) => row.EXECUTED_PRICE },
        { name: "Deal Amount", selector: (row) => row.DEAL_AMOUNT },
        { name: "Fees", selector: (row) => `${row.FEES} ${row.FEES_CURR}`, cell: (row) => <div className="text-secondary">{`${row.FEES} ${row.FEES_CURR}`}</div> },
        { name: "Paid/Get Paid", selector: (row) => row.FINAL_TOTAL, cell: (row) => <div className={parseFloat(row.FINAL_TOTAL) >= 0 ? "green_color" : "red_color"}>{row.FINAL_TOTAL}</div> },
    ];

    const handleRepetAPICall = () => {
        if (
            (data.fromDate != "" && data.fromDate != undefined) ||
            (data.todate != "" && data.todate != undefined) ||
            (data.pairFirst != "" && data.pairFirst != undefined) ||
            (data.pairLast != "" && data.pairLast != undefined) ||
            (data.buySell != "" && data.buySell != undefined)
        ) {
            GetUserExchangeOrders(currentPage, rowsPerPage, activeTab, data.fromDate, data.todate, data.pairFirst, data.pairLast, data.buySell);
            setBtnLoading(true);
        }
    };
    const handleReset = () => {
        setData({ fromDate: "", todate: "", pairFirst: "", pairLast: "", buySell: "" });
        if (
            (data.fromDate != "" && data.fromDate != undefined) ||
            (data.todate != "" && data.todate != undefined) ||
            (data.pairFirst != "" && data.pairFirst != undefined) ||
            (data.pairLast != "" && data.pairLast != undefined) ||
            (data.buySell != "" && data.buySell != undefined)
        ) {
            GetUserExchangeOrders(currentPage, rowsPerPage, activeTab);
        }
        setBtnLoading(false);
    };

    var column_data = activeTab === "PENDING" ? columns : activeTab === "ex-cancel" ? columns_ex_cancel : activeTab === "EXECUTED" ? columns_EXECUTED : "";
    var pdf_name = activeTab === "PENDING" ? "Open Orders" : activeTab === "ex-cancel" ? "Completed Orders" : activeTab === "EXECUTED" && "Trade History";

    return (
        <Layout>
            {/* {loading && <Loading />} */}
            <div>
                <div className="container">
                    <div className={styles.top_order_styyle}>
                        <div className="title_heading p-0">
                            {/* <p>Orders /</p> */}
                            <h4 className="ps-0">Spot Order</h4>
                        </div>
                        <div className="filter-box">
                            <ul className={`${styles.adv_filter} mb-0 pb-0`}>
                                <li className={styles.date_filter_main}>
                                    <div className={styles.date_filter}>
                                        <label>From Date</label>
                                        <div className={styles.input_box}>
                                            <DatePicker
                                                selectsStart
                                                selected={data.fromDate}
                                                onChange={(e) => {
                                                    setData({ ...data, fromDate: e });
                                                    setBtnLoading(false);
                                                }}
                                                startDate={data.fromDate}
                                                value={data.fromDate}
                                                maxDate={data.todate ? data.todate : maxDateString}
                                                dateFormat="dd/MM/yyyy" // Updated to use `yyyy`
                                                placeholderText="DD/MM/YYYY" // Updated to use `yyyy`
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </li>
                                <li className={styles.date_filter_main}>
                                    <div className={styles.date_filter}>
                                        <label>To Date</label>
                                        <div className={styles.input_box}>
                                            <DatePicker
                                                selectsStart
                                                selected={data.todate}
                                                onChange={(e) => {
                                                    setData({ ...data, todate: e });
                                                    setBtnLoading(false);
                                                }}
                                                startDate={data.todate}
                                                minDate={data.fromDate}
                                                maxDate={maxDateString}
                                                dateFormat="dd/MM/yyyy" // Updated to use `yyyy`
                                                placeholderText="DD/MM/YYYY" // Updated to use `yyyy`
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </li>
                                <li className={styles.date_filter_main}>
                                    <label>Pair</label>
                                    <div>
                                        <SelectField
                                            value={
                                                Array.from(new Set(coinPairsData && coinPairsData.map((obj) => obj.FIRST)))?.find((coin) => coin === data.pairFirst)
                                                    ? { value: data.pairFirst, label: data.pairFirst }
                                                    : null
                                            }
                                            optionSData={Array.from(new Set(coinPairsData && coinPairsData.map((obj) => obj.FIRST)))?.map((coin) => ({
                                                value: coin,
                                                label: coin,
                                            }))}
                                            placeholder=""
                                            onChangeData={(selectedOption) => {
                                                setData({ ...data, pairFirst: selectedOption?.value });
                                                setBtnLoading(false);
                                            }}
                                        />
                                    </div>
                                </li>
                                <li className={styles.date_filter_main}>
                                    <div className={styles.date_filter}>
                                        <label></label>
                                        <div>
                                            <SelectField
                                                value={
                                                    Array.from(new Set(coinPairsData && coinPairsData.map((obj) => obj.LAST)))?.find((coin) => coin === data.pairLast)
                                                        ? { value: data.pairLast, label: data.pairLast }
                                                        : null
                                                }
                                                optionSData={Array.from(new Set(coinPairsData && coinPairsData.map((obj) => obj.LAST)))?.map((coin) => ({
                                                    value: coin,
                                                    label: coin,
                                                }))}
                                                placeholder=""
                                                onChangeData={(selectedOption) => {
                                                    setData({ ...data, pairLast: selectedOption?.value });
                                                    setBtnLoading(false);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </li>
                                <li className={styles.date_filter_main}>
                                    <div className={styles.date_filter}>
                                        <label></label>
                                        <SelectField
                                            value={option.find((coin) => coin.value === data.buySell) ? { value: data.buySell, label: data.buySell } : null}
                                            optionSData={option}
                                            placeholder="Buy/Sell"
                                            onChangeData={(selectedOption) => {
                                                setData({ ...data, buySell: selectedOption.value });
                                                setBtnLoading(false);
                                            }}
                                        />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div className="d-flex filter-btns py-3">
                            <div className="col-6 col-lg-9">
                                <div className={styles.order_section_flex}>
                                    <ul>
                                        <li className="ms-0">
                                            <button
                                                type="button"
                                                disabled={userExchangeOrders.length === 0}
                                                className={styles.btn_dt}
                                                onClick={() => exportTableToPDF(userExchangeOrders, column_data, "order", pdf_name)}
                                            >
                                                <img src={PDFIcon} alt="" />
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                type="button"
                                                className={styles.btn_dt}
                                                onClick={() => exportTableToExcel(userExchangeOrders, excel_Name, column_data)}
                                                disabled={userExchangeOrders.length === 0}
                                            >
                                                <img src={excelIcon} alt="" />
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-6 col-lg-3">
                                <div className={`${styles.order_btn} text-center d-flex justify-content-end py-0`}>
                                    <button
                                        type="button"
                                        className={`${styles.button} primary_button me-3`}
                                        onClick={handleRepetAPICall}
                                        // disabled={data.todate === "" && data.fromDate === "" && data.buySell === "" && data.pairLast === "" && data.pairFirst === ""}
                                        disabled={btnLoading}
                                    >
                                        Search
                                        {btnLoading && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                                    </button>
                                    <button type="button" className={`${styles.button} primary_button`} onClick={handleReset}>
                                        Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.history_section_body}>
                    <div className="container">
                        <div className={styles.history_section_content}>
                            <div className={styles.history_section_text}>
                                <h4>{pdf_name}</h4>
                            </div>
                            <div className={styles.history_section_tab}>
                                <ul className={`${styles.tab} ${styles.navtabs}`}>
                                    <li className={styles.navitem}>
                                        <button className={`${styles.navlink} ${activeTab === "PENDING" ? styles.active : ""} ms-0`} aria-current="page" onClick={() => handleTabClick("PENDING")}>
                                            Open Orders
                                        </button>
                                    </li>
                                    <li className={styles.navitem}>
                                        <button className={`${styles.navlink} ${activeTab === "ex-cancel" ? styles.active : ""}`} onClick={() => handleTabClick("ex-cancel")}>
                                            Completed Orders
                                        </button>
                                    </li>
                                    <li className={styles.navitem}>
                                        <button className={`${styles.navlink} ${activeTab === "EXECUTED" ? styles.active : ""}`} onClick={() => handleTabClick("EXECUTED")}>
                                            Trade History
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="data_table_body m-0">
                            {loading ? (
                                <Table striped bordered hover>
                                    <thead>
                                        <tr className="border-1">
                                            <th className="border-0">Created</th>
                                            <th className="border-0">Pair</th>
                                            <th className="border-0">Buy/Sell</th>
                                            <th className="border-0">Type</th>
                                            <th className="border-0">Order Price</th>
                                            <th className="border-0">Volume</th>
                                            <th className="border-0">Total</th>
                                            {activeTab === "ex-cancel" || activeTab === "EXECUTED" ? (
                                                <>
                                                    <th className="border-0">Deal Price</th>
                                                    <th className="border-0">Deal Amount</th>
                                                    <th className="border-0">Fees</th>
                                                    <th className="border-0">Paid/Get Paid</th>
                                                    {activeTab === "ex-cancel" && <th className="border-0">Status</th>}
                                                </>
                                            ) : (
                                                <th className="border-0">Action</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody className="d-table-caption bg-white">
                                        <tr className="d-block w-100">
                                            <td className="d-block">
                                                <div className={styles.loader_market}>
                                                    <Loader />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            ) : userExchangeOrders && userExchangeOrders.length > 0 ? (
                                <DataTableComponents
                                    fetchData={GetUserExchangeOrders}
                                    columns={activeTab === "PENDING" ? columns : activeTab === "ex-cancel" ? columns_ex_cancel : activeTab === "EXECUTED" ? columns_EXECUTED : ""}
                                    userdata={userExchangeOrders}
                                    TotalRows={TotalRows}
                                    paginationDefaultPage={currentPage}
                                    paginationPerPage={rowsPerPage}
                                    onChangePage={handlePageChange}
                                    onChangeRowsPerPage={handleRowsPerPageChange}
                                />
                            ) : (
                                <Table striped bordered hover>
                                    <thead>
                                        <tr className="border-1">
                                            <th className="border-0">Created</th>
                                            <th className="border-0">Pair</th>
                                            <th className="border-0">Buy/Sell</th>
                                            <th className="border-0">Type</th>
                                            <th className="border-0">Order Price</th>
                                            <th className="border-0">Volume</th>
                                            <th className="border-0">Total</th>
                                            <th className="border-0">Action</th>
                                        </tr>
                                    </thead>
                                    <NoDataFoundImg />
                                </Table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
